









































































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import FormField from '@ui/FormBuilder/FormField'
import WizardNavigation from '@superComponents/BrandRep/TransferWizard/WizardNavigation'

settings =
  name: 'SetupSameAccountStep'

  vue:
    props: ['wizard', 'step']

    components: {
      Modal,
      FormField,
      WizardNavigation,
    }

    data: ->
      confirmModal:
        show: false

    computed:
      brandRepStats: ->
        @ctxStats @wizard.brandRep

      canTransfer: ->
        !!@wizard.form.to_email

      inputPropsForCustomSettings: ->
        items: [
          {
            key: 'find_replace_all'
            label: 'Find all and replace'
            description: 'Find and replace all email contacts'
          }
        ]

    methods:
      hiPromptTransfer: ->
        @confirmModal.show = true

      hiTransfer: ->
        @wizard.transfer()

export default VueOptions.vue settings
